/**
 * Formats the reservation time period for display
 * @param startDate - ISO string of start date/time
 * @param endDate - ISO string of end date/time
 * @param locale - The locale for formatting
 * @returns Formatted time period string
 */

/**
 * Formats just the start date for recurring reservations (no time)
 * @param startDate - ISO string of start date/time
 * @param locale - The locale for formatting
 * @returns Formatted date string without time
 */
export function formatRecurringReservationDate(startDate: string, locale: string = "en"): string {
  const startDateTime = new Date(startDate);
  
  const dateOptions: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  };
  
  return startDateTime.toLocaleDateString(locale, dateOptions);
}

// TODO: timezone should be considered for accurate time representation
export function formatReservationTime(startDate: string, endDate: string, locale: string = "en"): string {
  const startDateTime = new Date(startDate);
  const endDateTime = new Date(endDate);
  
  // Check if both dates are on the same day
  const isSameDay = startDateTime.toDateString() === endDateTime.toDateString();
  
  if (isSameDay) {
    // Format: "11.06.2025 19:00 - 20:00"
    const dateOptions: Intl.DateTimeFormatOptions = {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    };
    
    const timeOptions: Intl.DateTimeFormatOptions = {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    };
    
    const formattedDate = startDateTime.toLocaleDateString(locale, dateOptions);
    const startTime = startDateTime.toLocaleTimeString(locale, timeOptions);
    const endTime = endDateTime.toLocaleTimeString(locale, timeOptions);
    
    return `${formattedDate} ${startTime} - ${endTime}`;
  } else {
    // Format: "11.06.2025 19:00 - 12.06.2025 20:00"
    const dateTimeOptions: Intl.DateTimeFormatOptions = {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    };
    
    const startFormatted = startDateTime.toLocaleString(locale, dateTimeOptions);
    const endFormatted = endDateTime.toLocaleString(locale, dateTimeOptions);
    
    return `${startFormatted} - ${endFormatted}`;
  }
}